<div class="page">
  <app-navbar></app-navbar>
  <app-about></app-about>
  <app-projects></app-projects>
  <app-skills></app-skills>
  <app-experience></app-experience>
  <app-education></app-education>
  <app-interests></app-interests>
</div>